import { useMutation, useQuery, useQueryClient } from 'react-query';
import { get, post } from '../fetch';

export const useGetMemberBffData = (disable = false) => {
  return useQuery('member-data', () => get<Member.IBffMember>('/bff/api/member', undefined, true), {
    enabled: !disable,
    cacheTime: 0,
    suspense: false,
  });
};

export const useUpdateMember = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (member: Member.IMember) =>
      post<Member.IMember, Member.IMember>('/bff/api/member', member, undefined, true),
    {
      onSuccess: (member: Member.IMember) => {
        queryClient.setQueryData('member-data', (oldMember) => {
          if (!oldMember) return oldMember;

          return {
            ...oldMember,
            member: member,
          };
        });
      },
    },
  );
};
